var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';
import { Card, CardBody, CardHeader } from 'reactstrap';
import Page from '../Page';
import { notifyUncaughtErrors } from '../../../utils/errorUtils';
import { ApplicationContext } from '../../../ApplicationContext';
import GetOrganisationArchivedAssetsCommand from '../../../commands/assets/GetOrganisationArchivedAssetsCommand';
import AssetArchiveRow from './AssetArchiveRow';
import { EmptyDivRow } from '../../components/ui/EmptyRow/EmptyRow';
/**
 *
 */
var AssetArchive = /** @class */ (function (_super) {
    __extends(AssetArchive, _super);
    /**
     *
     */
    function AssetArchive(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: []
        };
        _this.updateAssets = _this.updateAssets.bind(_this);
        _this.onSearchChange = _this.onSearchChange.bind(_this);
        _this.onSortClick = _this.onSortClick.bind(_this);
        return _this;
    }
    /**
     *
     */
    AssetArchive.prototype.componentDidMount = function () {
        this.updateAssets();
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    AssetArchive.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     */
    AssetArchive.prototype.componentWillUnmount = function () {
    };
    /**
     *
     * @returns {*}
     */
    AssetArchive.prototype.render = function () {
        var _a = this.context, session = _a.session, archivedAssetCollection = _a.archivedAssetCollection;
        var intl = this.props.intl;
        if (!archivedAssetCollection)
            return null;
        var classes = classNames({
            'asset-archive': true
        });
        return (React.createElement(Page, { pageName: classes },
            React.createElement("div", { className: "pb-4 h-100" },
                React.createElement(Card, { className: "mh-100", style: { width: "95%", borderRadius: "0px 20px 20px 0px" } },
                    React.createElement(CardHeader, { className: "flex-grow-0 pb-0 align-teims-start" },
                        React.createElement("h1", { className: "card-header-title" },
                            React.createElement(FormattedMessage, { id: "page.assets.archive.title" }))),
                    React.createElement(CardBody, { className: "overflow-auto pt-0 mr-4 pr-0" },
                        React.createElement("div", { className: "table-container w-100 h-100 flex-fill" },
                            React.createElement("div", { className: "w-100", style: {
                                    display: "grid",
                                    gridTemplateColumns: "2fr 2fr 2fr 2fr 2fr 5fr 1fr",
                                    rowGap: "1.3rem",
                                    minWidth: "fit-content"
                                } },
                                React.createElement("div", { className: 'w-100 cursor-pointer position-sticky text-nowrap text-uppercase bg-secondary px-3 pb-2 table-header', style: { display: "contents", top: 0, zIndex: 1 } },
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "id" },
                                        React.createElement(FormattedMessage, { id: "page.assets.table.column.id" })),
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "make" },
                                        React.createElement(FormattedMessage, { id: "page.assets.table.column.make" })),
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "model" },
                                        React.createElement(FormattedMessage, { id: "page.assets.table.column.model" })),
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "serialNumber" },
                                        React.createElement(FormattedMessage, { id: "page.assets.table.column.serialnumber" })),
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "lastModifiedTimestamp" },
                                        React.createElement(FormattedMessage, { id: "page.assets.table.column.archivedate" })),
                                    React.createElement("div", { onClick: this.onSortClick, "data-sortBy": "reason" },
                                        React.createElement(FormattedMessage, { id: "page.assets.table.column.reason" })),
                                    React.createElement("div", null)),
                                archivedAssetCollection.filteredAndSorted.length > 0 ?
                                    archivedAssetCollection.filteredAndSorted.map(function (archivedAssetModel) {
                                        return React.createElement(AssetArchiveRow, { key: archivedAssetModel.id, archivedAssetModel: archivedAssetModel, archivedAssetCollection: archivedAssetCollection });
                                    }) : React.createElement(EmptyDivRow, null))))))));
    };
    /**
     *
     * @param event
     */
    AssetArchive.prototype.onSortClick = function (event) {
        var archivedAssetCollection = this.context.archivedAssetCollection;
        var sort = archivedAssetCollection.sort;
        var fieldName = event.target.dataset.sortby;
        var direction = sort.fieldName === fieldName ? sort.direction * -1 : 1;
        archivedAssetCollection.sort.update({ fieldName: event.target.dataset.sortby, direction: direction });
        archivedAssetCollection.updateSortCache();
    };
    /**
     *
     * @param value
     */
    AssetArchive.prototype.onSearchChange = function (value) {
        var archivedAssetCollection = this.context.archivedAssetCollection;
        archivedAssetCollection.searchStringFilter.value = value.toLowerCase();
        archivedAssetCollection.update();
    };
    /**
     *
     */
    AssetArchive.prototype.updateAssets = function () {
        var _a = this.context, session = _a.session, archivedAssetCollection = _a.archivedAssetCollection;
        var user = session.user;
        var command = new GetOrganisationArchivedAssetsCommand();
        command.execute(user.organisation, archivedAssetCollection);
    };
    AssetArchive = __decorate([
        observer
    ], AssetArchive);
    return AssetArchive;
}(React.Component));
AssetArchive.contextType = ApplicationContext;
export default injectIntl(AssetArchive);
